import React, { useState } from 'react';

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Static credentials for demo
  const validCredentials = {
    'admin': 'admin123',
    'demo_user': 'demo123',
    'user': 'password'
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Simulate API delay for realistic demo
    setTimeout(() => {
      const { username, password } = formData;
      
      if (validCredentials[username] && validCredentials[username] === password) {
        // Set a mock token for demo purposes
        localStorage.setItem('token', 'demo-token-' + Date.now());
        onLogin();
      } else {
        setError('Invalid username or password. Please try again.');
      }
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="container" style={{ maxWidth: '400px', marginTop: '100px' }}>
      <div className="card">
        <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>OTX Vehicle Monitor</h2>
        
        {error && <div className="error">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="Enter username"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter password"
            />
          </div>
          
          <button 
            type="submit" 
            className="btn btn-primary"
            style={{ width: '100%' }}
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        
        <div style={{ marginTop: '20px', fontSize: '12px', color: '#666', textAlign: 'center' }}>
          <p><strong>Demo credentials:</strong></p>
          <p>admin / admin123</p>
          <p>demo_user / demo123</p>
          <p>user / password</p>
          
          <div style={{ marginTop: '15px', padding: '10px', backgroundColor: '#e8f5e8', borderRadius: '4px' }}>
            <p style={{ color: '#28a745', fontWeight: 'bold' }}>
              ✓ Demo Mode - Using Static Data
            </p>
            <p style={{ fontSize: '11px', color: '#666' }}>
              No backend connection required
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
